import { FC, memo } from 'react'

import { HistoryTable } from 'bank-entity-history'
import { TableDataQa } from 'commons/types/enums'
import { PageSection, PageSectionFace } from 'ui/components/Page'

import { HistoryProps } from './History.types'

export const History: FC<HistoryProps> = memo((props) => {
  const { data, onFilterChange, isFetching } = props
  const {
    history,
    historyTotalCount,
    form: { historyPage, historySize }
  } = data

  return (
    <PageSection face={PageSectionFace.THIRD} title="History" anchor="history">
      <HistoryTable
        dataQa={TableDataQa.BP_BSA_REPORTING_SAR_HISTORY}
        items={history}
        pagination={{
          page: historyPage,
          size: historySize,
          onChange: onFilterChange,
          total: historyTotalCount
        }}
        loading={isFetching}
      />
    </PageSection>
  )
})
